import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { RolesPage, rolesQueryOptions } from '@/features/team';

export const Route = createFileRoute('/_authed/_active/org/roles')({
  staticData: { crumb: 'common:nav.roles', tours: ['org.roles'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'staff.read');
  },
  loader: ({ context }) =>
    context.queryClient
      .query({ ...rolesQueryOptions(), staleTime: 'static' })
      .catch(() => undefined),
  component: RolesPage,
});
